import React from 'react'
import cn from 'classnames'
// Components
import { capitalizeFirstLetterOfTitle } from '@utils'
import styles from './SimpleInput.module.scss'

const SimpleInput = ({
  type,
  value,
  showError,
  placeholder,
  onChange,
  label,
}) => {
  return (
    <div className={styles.inputContainer}>
      <label htmlFor="input">{capitalizeFirstLetterOfTitle(label)}</label>
      <input
        name="input"
        className={cn({
          [styles.simpleInput]: true,
          [styles.showError]: showError,
        })}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />

      {showError && (
        <>
          <div className={styles.icon} />
          <div className={styles.error}>
            <div className={styles.message}>Please enter a valid {label}</div>
          </div>
        </>
      )}
    </div>
  )
}

export default SimpleInput
